<template>
  <img class="img-thumbnail" :src="src || noPhoto" />
</template>

<script>

import noPhoto from "@/assets/images/no-photo.jpg";

export default {
  name: 'thumb',
  props: [
    'src'
  ],
  data() {
    return { noPhoto}
  }
};
</script>

